module.exports = __webpack_public_path__ + "img/construction-sign.9c6a0267.gif";